export const Sparkline = ({ data = [], width = 110, height = 34, testid }) => {
  if (data.length < 2) return <div style={{ width, height }} />;
  const min = Math.min(...data), max = Math.max(...data);
  const pts = data.map((v, i) => `${(i / (data.length - 1)) * width},${height - ((v - min) / (max - min || 1)) * (height - 4) - 2}`).join(" ");
  const up = data[data.length - 1] >= data[0];
  return (
    <svg width={width} height={height} data-testid={testid} aria-hidden="true">
      <polyline points={pts} fill="none" strokeWidth="1.6" stroke={up ? "hsl(var(--up))" : "hsl(var(--down))"} />
    </svg>
  );
};
